import React, { memo } from "react"
import PropTypes from "prop-types"
import {
    Card,
    CardBody,
    Col,
} from "reactstrap"
import './basic.css';

const OrderDetails = ({ title = '', package_orders = 0, current_orders = 0, colSize = 3 }) => {
    const isUnlimited = package_orders === 'unlimited';
    const periodOrderColor = !isUnlimited && parseInt(package_orders) < parseInt(current_orders) ? "red" : "Highlight";

    return (
        <Col xl={colSize}>
            <Card>
                <CardBody>
                    <div className="d-flex flex-wrap d-between-flex">
                        <h3 className="card-title mb-3 me-2">{title}</h3>
                    </div>
                    <div>
                        <h6 className="mb-3">
                            Package Orders: <span style={{ color: "Highlight" }}>{package_orders}</span>
                        </h6>
                        {!isUnlimited && (
                            <h6 className="mb-1">
                                Period Orders: <span style={{ fontSize: '14px', fontWeight: 'bold', color: periodOrderColor }}>{current_orders}</span>
                            </h6>
                        )}
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

OrderDetails.propTypes = {
    title: PropTypes.string,
    package_orders: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    current_orders: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    colSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default memo(OrderDetails)
